import { Segmented } from 'antd';
import styled from 'styled-components';

export default styled(Segmented)`
	// Add your styles here
`;
